export * from "-!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./EditHeatmapOrGridDataContainer.vue?vue&type=template&id=8c11edd6&"


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/EditHeatmapOrGridDataContainer.vue?vue&type=template&id=8c11edd6&
// module id = 65
// module chunks = 0